import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoVideoItems from 'eco-design/sections/eco-video-items';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.ListA4');
    const itemsA = [
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1744103122073/list4_icon_1.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103120892/list4_1.jpg',
            title: t('list1_title'),
            useName1: t('list1_name'),
            useName2: t('list1_counts'),
            videoSrc: 'https://www.youtube.com/embed/dyStPyMNyLg?si=aNPd_6sj0xjuTsmM',
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1744103190450/list4_icon_2.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103122576/list4_2.jpg',
            title: t('list2_title'),
            useName1: t('list2_name'),
            useName2: t('list2_counts'),
            videoSrc: 'https://www.youtube.com/embed/UrYZ1XjzbFw?si=DpFE456gfFzIVvo_',
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1744103121834/list4_icon_3.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103122320/list4_3.jpg',
            title: t('list3_title'),
            useName1: t('list3_name'),
            useName2: t('list3_counts'),
            videoSrc: 'https://www.youtube.com/embed/eLGKdLawyds?si=rqGREqz362a8mtlW',
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1744103213733/list4_icon_4.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744103122840/list4_4.jpg',
            title: t('list4_title'),
            useName1: t('list4_name'),
            useName2: t('list4_counts'),
            videoSrc: 'https://www.youtube.com/embed/5eFGNE0g8VU?si=HEbuwF9vaJB-cDEk',
        },
    ];
    return (
        <div className={`${styles.comp}`}>
            <EcoSectionCommon
                sectionCommonLayout="left"
                title={t('title')}
                desc={t('desc')}
                lDataLayer={{
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: 'none',
                    position: 'Collections_Join Facebook Group',
                }}
            />
            <EcoSpaceSmall />
            <EcoVideoItems items={itemsA} />
            <EcoSpace />
        </div>
    );
}
